<div *ngIf="!hidden" class="componentWrapper" id="{{component.id}}">
    <div>{{label}}</div>
    <div [class]="'grid-container ' + 'grid-container' + noOfColumns"
                   [ngStyle]="{'grid-gap': getOptionByKeyWithDefault('gridGap', 5)+'px' }">
        <ng-container *ngFor="let subcomponent of component.components">
            <div
                 [ngClass]="{
                        'hidden-element': isHidden(subcomponent),
                        'align-content-center': hasOptionValue(subcomponent, 'alignContent', 'center'),
                        'align-content-left': hasOptionValue(subcomponent, 'alignContent', 'left'),
                        'colspan2': hasOptionValue(subcomponent, 'colspan', '2'),
                        'colspan3': hasOptionValue(subcomponent, 'colspan', '3'),
                        'colspan4': hasOptionValue(subcomponent, 'colspan', 4),
                        'colspan5': hasOptionValue(subcomponent, 'colspan', 5),
                        'colspan6': hasOptionValue(subcomponent, 'colspan', 6),
                        'colspan7': hasOptionValue(subcomponent, 'colspan', 7),
                        'colspan8': hasOptionValue(subcomponent, 'colspan', 8),
                        'colspan9': hasOptionValue(subcomponent, 'colspan', 9),
                        'colspan10': hasOptionValue(subcomponent, 'colspan', 10),
                        'colspan11': hasOptionValue(subcomponent, 'colspan', 11),
                        'colspan12': hasOptionValue(subcomponent, 'colspan', 12)
                }">
                <dynamic-renderer [component]="subcomponent" [data]="data" [formGroup]="formGroup"></dynamic-renderer>
            </div>
        </ng-container>
    </div>
</div>
